The type of event, i.e. PositionProfilePosted. This corresponds to the `Event.typeCode` field in the GraphQL schema.
